import React, { useState } from "react";
import "./OnlineCalculator.css";
import { Link } from "react-router-dom";
import BackBtn from "../../Components/BackBtn/BackBtn";
import HamburgerMenu from "../../Components/HamburgerMenu/HamburgerMenu";
import calculatorData from "./calculatorData";
import BottomBar from "../../Components/BottomBar/BottomBar";

export default function OnlineCalculator() {
  const [showHamburgerMenu, setShowHamburgerMenu] = useState(false);
  const [openCalculator, setOpenCalculator] = useState(false);
  const [calculatedName, setCalculatedName] = useState("");

  const hamburgerMenuHandler = () => {
    setShowHamburgerMenu(true);
  };

  const hideMenuHandler = () => {
    setShowHamburgerMenu(false);
  };

  const startCalculating = (item) => {
    setOpenCalculator(true);
    setCalculatedName(item.title);
  };

  return (
    <div className="gymBg bgContainer">
      <HamburgerMenu
        showHamburgerMenu={showHamburgerMenu}
        onHide={hideMenuHandler}
      />
      <div className="blurOverlay">
        <div className="pageWrapper">
          <div className="pageHeader centeredFlex">
            <BackBtn />
            <img
              src="/images/ic_menu.svg"
              alt="menu"
              className="menuIcon"
              onClick={hamburgerMenuHandler}
            />
          </div>
          <div className="pageTitle horizontalBorder">
            {openCalculator ? calculatedName : "محاسبه گر آنلاین"}
          </div>
          <div className="calculatorItems responsiveWidth">
            {calculatorData.map((item) => (
              <Link
                key={item.id}
                to={item.link}
                className="calculatorItem horizontalBorder centeredFlex link"
                onClick={() => startCalculating({ ...item })}
              >
                <img
                  src="/images/arrowSquareRight.svg"
                  alt="arrow icon"
                  className="calculatorArrowIcon"
                />
                <div className="calculatorItemText centeredFlex">
                  <p>{item.title}</p>
                  <span>measurements calculators</span>
                </div>
                <img
                  src={item.img}
                  alt="calculators icon"
                  className="calculatorImg"
                />
              </Link>
            ))}
          </div>
        </div>
      </div>
      <BottomBar />
    </div>
  );
}
